
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('path',{attrs:{"d":"M7.029 10.714c-.9 0-1.389-1.165-.713-1.888l4.952-5.464a.972.972 0 01.75-.362.9.9 0 01.714.362l4.952 5.464c.676.723.188 1.888-.713 1.888H7.03z"}}),_c('path',{attrs:{"d":"M16.971 13.286c.9 0 1.389 1.205.713 1.928l-4.952 5.465c-.188.24-.45.321-.713.321-.3 0-.563-.08-.75-.321l-4.953-5.465c-.676-.723-.188-1.928.713-1.928h9.942z","opacity":".4"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      